import { useCallback, useState } from "react";
import {
    ReportTemplatesView,
    ReportTemplatesViewSchema,
} from "@common/types/views/reportTemplatesView";
import { View } from "@common/types/views/views";
import {
    WORKSPACE_USER_CACHE_KEYS,
    useWorkspaceUserCache,
} from "@hooks/useWorkspaceUserCache";
import { mergeCachedView } from "@lib/mergeCachedView";
import { reportTemplatesViewConfig } from "./reportTemplatesViewConfig";
import { defaultReportTemplatesView } from "./reportTemplatesView";

export function useReportTemplatesView() {
    const [cachedView, setCachedView] =
        useWorkspaceUserCache<ReportTemplatesView>(
            WORKSPACE_USER_CACHE_KEYS.REPORT_TEMPLATES_PAGE_VIEW_CACHE_KEY,
            ReportTemplatesViewSchema,
        );
    const [view, setView] = useState<ReportTemplatesView>(() =>
        mergeCachedView(
            cachedView,
            defaultReportTemplatesView,
            reportTemplatesViewConfig,
        ),
    );

    const handleViewChange = useCallback(
        (newView: View) => {
            const parsed = ReportTemplatesViewSchema.safeParse(newView);
            if (!parsed.success) {
                return;
            }
            setView(parsed.data);
            setCachedView(parsed.data);
        },
        [setCachedView],
    );

    return { view, handleViewChange };
}
